import { Box, Container, Stack, Link as MuiLink, IconButton } from "@mui/material";
import { Instagram, Facebook, LinkedIn } from "@mui/icons-material";
import RevaText from "components/common/RevaText";

export default function Footer() {
  return (
    <Box sx={{ bgcolor: "black", py: 4 }}>
      <Container maxWidth="md">
        <Stack spacing={3} direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems="center">
          {/* Nombre o logo */}
          <Stack alignItems={{ xs: "center", sm: "flex-start" }}>
            <Box component="img" src="/logos/isologo-white.png" alt="Disponible en Google Play" sx={{ height: 30 }} />
            <RevaText
              id="La app para torneos y reservas deportivas"
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.5 }}
            />
          </Stack>

          {/* Redes sociales */}
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 0 }}>
            <IconButton
              component="a"
              href="https://www.instagram.com/reva.sports" // Reemplazá con tu link real
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <Instagram />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.facebook.com/revaapp.co" // opcional
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
            >
              <Facebook />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.linkedin.com/company/reva-app" // opcional
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <LinkedIn />
            </IconButton>
          </Stack>
          {/* Botones de descarga */}
          <Stack direction="row" spacing={1} sx={{ mt: { xs: 2, sm: 0 } }}>
            <MuiLink
              href="https://play.google.com/store/apps/details?id=py.com.kynox.pelotajara"
              target="_blank"
              rel="noopener"
            >
              <Box
                component="img"
                src="/img/google-play-badge.png"
                alt="Disponible en Google Play"
                sx={{ height: 40 }}
              />
            </MuiLink>
            <MuiLink href="https://apps.apple.com/app/id1312023245" target="_blank" rel="noopener">
              <Box
                component="img"
                src="/img/app-store-badge-white.svg"
                alt="Disponible en App Store"
                sx={{ height: 40 }}
              />
            </MuiLink>
          </Stack>
        </Stack>

        {/* Línea final */}
        <RevaText
          id="organization.footer.rights"
          values={{ year: new Date().getFullYear() }}
          variant="caption"
          color="text.secondary"
          display="block"
          sx={{ mt: 4, textAlign: "center" }}
        />
      </Container>
    </Box>
  );
}
